module.exports = __webpack_public_path__ + "static/img/yagi_02.db16413.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_02.jpg
// module id = MmZj
// module chunks = 0